import React from 'react';

import { AssetsLoading } from '../../../AssetsLoading';
import { AssetErrorListing } from '../AssetErrorListing';
import { AssetNotFound } from '../AssetNotFound';

export interface ListEmptyProps {
  hasError: boolean;
  isLoading: boolean;
  hasData: boolean;
  ProductItemLoading: React.FC;
}

export const ListEmpty: React.FC<ListEmptyProps> = ({
  hasError,
  hasData,
  isLoading,
  ProductItemLoading,
}) => {
  if (hasError) {
    return <AssetErrorListing />;
  }

  if (!isLoading && !hasData) {
    return <AssetNotFound />;
  }

  return <AssetsLoading ProductItemLoading={ProductItemLoading} quantity={5} />;
};
